import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nr-summary',
  templateUrl: './nr-summary.component.html',
  styleUrls: ['./nr-summary.component.scss']
})
export class NrSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
